export var bg;
(function (bg) {
    bg.names = {
        AD: "Андора",
        AE: "Обединени арабски емирства",
        AF: "Афганистан",
        AG: "Антигуа и Барбуда",
        AI: "Ангуила",
        AL: "Албания",
        AM: "Армения",
        AO: "Ангола",
        AQ: "Антарктика",
        AR: "Аржентина",
        AS: "Американска Самоа",
        AT: "Австрия",
        AU: "Австралия",
        AW: "Аруба",
        AX: "Оландски острови",
        AZ: "Азербайджан",
        BA: "Босна и Херцеговина",
        BB: "Барбадос",
        BD: "Бангладеш",
        BE: "Белгия",
        BF: "Буркина Фасо",
        BG: "България",
        BH: "Бахрейн",
        BI: "Бурунди",
        BJ: "Бенин",
        BL: "Сен Бартелеми",
        BM: "Бермуда",
        BN: "Бруней Даруссалам",
        BO: "Боливия",
        BQ: "Карибска Нидерландия",
        BR: "Бразилия",
        BS: "Бахами",
        BT: "Бутан",
        BV: "остров Буве",
        BW: "Ботсвана",
        BY: "Беларус",
        BZ: "Белиз",
        CA: "Канада",
        CC: "Кокосови острови (острови Кийлинг)",
        CD: "Конго (Киншаса)",
        CF: "Централноафриканска република",
        CG: "Конго (Бразавил)",
        CH: "Швейцария",
        CI: "Кот д’Ивоар",
        CK: "острови Кук",
        CL: "Чили",
        CM: "Камерун",
        CN: "Китай",
        CO: "Колумбия",
        CR: "Коста Рика",
        CU: "Куба",
        CV: "Кабо Верде",
        CW: "Кюрасао",
        CX: "остров Рождество",
        CY: "Кипър",
        CZ: "Чехия",
        DE: "Германия",
        DJ: "Джибути",
        DK: "Дания",
        DM: "Доминика",
        DO: "Доминиканска република",
        DZ: "Алжир",
        EC: "Еквадор",
        EE: "Естония",
        EG: "Египет",
        EH: "Западна Сахара",
        ER: "Еритрея",
        ES: "Испания",
        ET: "Етиопия",
        FI: "Финландия",
        FJ: "Фиджи",
        FK: "Фолклендски острови",
        FM: "Микронезия",
        FO: "Фарьорски острови",
        FR: "Франция",
        GA: "Габон",
        GB: "Обединеното кралство",
        GD: "Гренада",
        GE: "Грузия",
        GF: "Френска Гвиана",
        GG: "Гърнзи",
        GH: "Гана",
        GI: "Гибралтар",
        GL: "Гренландия",
        GM: "Гамбия",
        GN: "Гвинея",
        GP: "Гваделупа",
        GQ: "Екваториална Гвинея",
        GR: "Гърция",
        GS: "Южна Джорджия и Южни Сандвичеви острови",
        GT: "Гватемала",
        GU: "Гуам",
        GW: "Гвинея-Бисау",
        GY: "Гаяна",
        HK: "Хонконг, САР на Китай",
        HM: "остров Хърд и острови Макдоналд",
        HN: "Хондурас",
        HR: "Хърватия",
        HT: "Хаити",
        HU: "Унгария",
        ID: "Индонезия",
        IE: "Ирландия",
        IL: "Израел",
        IM: "остров Ман",
        IN: "Индия",
        IO: "Британска територия в Индийския океан",
        IQ: "Ирак",
        IR: "Иран",
        IS: "Исландия",
        IT: "Италия",
        JE: "Джърси",
        JM: "Ямайка",
        JO: "Йордания",
        JP: "Япония",
        KE: "Кения",
        KG: "Киргизстан",
        KH: "Камбоджа",
        KI: "Кирибати",
        KM: "Коморски острови",
        KN: "Сейнт Китс и Невис",
        KP: "Северна Корея",
        KR: "Южна Корея",
        KW: "Кувейт",
        KY: "Кайманови острови",
        KZ: "Казахстан",
        LA: "Лаос",
        LB: "Ливан",
        LC: "Сейнт Лусия",
        LI: "Лихтенщайн",
        LK: "Шри Ланка",
        LR: "Либерия",
        LS: "Лесото",
        LT: "Литва",
        LU: "Люксембург",
        LV: "Латвия",
        LY: "Либия",
        MA: "Мароко",
        MC: "Монако",
        MD: "Молдова",
        ME: "Черна гора",
        MF: "Сен Мартен",
        MG: "Мадагаскар",
        MH: "Маршалови острови",
        MK: "Македония",
        ML: "Мали",
        MM: "Мианмар (Бирма)",
        MN: "Монголия",
        MO: "Макао, САР на Китай",
        MP: "Северни Мариански острови",
        MQ: "Мартиника",
        MR: "Мавритания",
        MS: "Монтсерат",
        MT: "Малта",
        MU: "Мавриций",
        MV: "Малдиви",
        MW: "Малави",
        MX: "Мексико",
        MY: "Малайзия",
        MZ: "Мозамбик",
        NA: "Намибия",
        NC: "Нова Каледония",
        NE: "Нигер",
        NF: "остров Норфолк",
        NG: "Нигерия",
        NI: "Никарагуа",
        NL: "Нидерландия",
        NO: "Норвегия",
        NP: "Непал",
        NR: "Науру",
        NU: "Ниуе",
        NZ: "Нова Зеландия",
        OM: "Оман",
        PA: "Панама",
        PE: "Перу",
        PF: "Френска Полинезия",
        PG: "Папуа-Нова Гвинея",
        PH: "Филипини",
        PK: "Пакистан",
        PL: "Полша",
        PM: "Сен Пиер и Микелон",
        PN: "Острови Питкерн",
        PR: "Пуерто Рико",
        PS: "Палестински територии",
        PT: "Португалия",
        PW: "Палау",
        PY: "Парагвай",
        QA: "Катар",
        RE: "Реюнион",
        RO: "Румъния",
        RS: "Сърбия",
        RU: "Русия",
        RW: "Руанда",
        SA: "Саудитска Арабия",
        SB: "Соломонови острови",
        SC: "Сейшели",
        SD: "Судан",
        SE: "Швеция",
        SG: "Сингапур",
        SH: "Света Елена",
        SI: "Словения",
        SJ: "Свалбард и Ян Майен",
        SK: "Словакия",
        SL: "Сиера Леоне",
        SM: "Сан Марино",
        SN: "Сенегал",
        SO: "Сомалия",
        SR: "Суринам",
        SS: "Южен Судан",
        ST: "Сао Томе и Принсипи",
        SV: "Салвадор",
        SX: "Синт Мартен",
        SY: "Сирия",
        SZ: "Свазиленд",
        TC: "острови Търкс и Кайкос",
        TD: "Чад",
        TF: "Френски южни територии",
        TG: "Того",
        TH: "Тайланд",
        TJ: "Таджикистан",
        TK: "Токелау",
        TL: "Източен Тимор",
        TM: "Туркменистан",
        TN: "Тунис",
        TO: "Тонга",
        TR: "Турция",
        TT: "Тринидад и Тобаго",
        TV: "Тувалу",
        TW: "Тайван",
        TZ: "Танзания",
        UA: "Украйна",
        UG: "Уганда",
        UM: "Отдалечени острови на САЩ",
        US: "Съединени щати",
        UY: "Уругвай",
        UZ: "Узбекистан",
        VA: "Ватикан",
        VC: "Сейнт Винсънт и Гренадини",
        VE: "Венецуела",
        VG: "Британски Вирджински острови",
        VI: "Американски Вирджински острови",
        VN: "Виетнам",
        VU: "Вануату",
        WF: "Уолис и Футуна",
        WS: "Самоа",
        XK: "Косово",
        YE: "Йемен",
        YT: "Майот",
        ZA: "Южна Африка",
        ZM: "Замбия",
        ZW: "Зимбабв",
    };
})(bg || (bg = {}));
//# sourceMappingURL=bg.js.map